import styles from './style.module.scss';
import { Button, PageHeader } from 'components';
import { PlusOutlined } from '@ant-design/icons';
import { Col, Table, Row, Divider, Input } from 'antd';
import { Link, Route, Routes } from 'react-router-dom';
import DeleteModal from 'components/deleteModalView';
import { useTranslation } from 'react-i18next';
import useContactRole from '../useContactRole';
import { useRecoilValue } from 'recoil';
import { getPage } from 'hooks/useUser';
import { ExcelIcon } from '../../../../../icons';
import FilterWrapper from '../../../../../components/filters/wrapper';
import { useCallback, useMemo, useState } from 'react';

const MainPage = () => {
  const [value, setValue] = useState('');
  const {
    data,
    columns,
    loading,
    onDelete,
    updateInProcess,
    onChangeTableFilter,
    handleDownloadExcel,
  } = useContactRole();
  const { t } = useTranslation();
  const pages = useRecoilValue(getPage);

  const onChangeTitle = useCallback((e) => {
    setValue(e.target.value);
  }, []);

  const preparedData = useMemo(() => {
    if (!value) return data.contact_roles;

    return data.contact_roles.filter(i => i.title?.toLowerCase().includes(value.toLowerCase()));
  }, [data, value]);

  return (
    <>
      <PageHeader title={t('Ruoli contatti commerciali').toUpperCase()}>
        <Row gutter={16}>
          {pages?.ability?.can_create && (
            <Col>
              <Link to={'new'}>
                <Button width={'138px'} big icon={<PlusOutlined />}>
                  {t('NUOVO')}
                </Button>
              </Link>
            </Col>
          )}
          <Col>
            <Button
              big
              type={'green'}
              iconMargin
              width={'138px'}
              icon={<ExcelIcon fill={'#fff'} />}
              onClick={handleDownloadExcel}
              loading={loading}
            >
              {t('Export')}
            </Button>
          </Col>
        </Row>
      </PageHeader>
      <div className={styles.container}>
        <Row wrap={false}>
          <Col flex={1}>
            <Row gutter={[16, 16]}>
              <Col>
                <FilterWrapper
                  hideClose={true}
                  title={t('Titolo')}
                >
                  <Input
                    placeholder={t('Titolo')}
                    bordered={false}
                    onChange={onChangeTitle}
                    value={value}
                  />
                </FilterWrapper>
              </Col>
            </Row>
          </Col>
        </Row>
        <Divider />
        <Table
          columns={columns}
          dataSource={preparedData}
          pagination={data.pagination}
          loading={loading}
          onChange={onChangeTableFilter}
          scroll={{ x: 1500 }}
        // bordered
        />
      </div>
      <Routes>
        <Route
          path={':id/delete'}
          element={
            <DeleteModal loading={updateInProcess} onClickDelete={onDelete} />
          }
        />
      </Routes>
    </>
  );
};

export default MainPage;
